import STEP_1 from './Step1';
import STEP_2 from './Step2';

export const localStorageKey = 'disable_virtual_event_onboarding_edit_page';

export const STEPS = [STEP_1, STEP_2];
